








import Component from 'vue-class-component';

import PageLayout from '@/common/layout/PageLayout.vue';
import { Page } from '@/layout/mixin/Page';

@Component({
  components: {
    PageLayout
  }
})
export default class WorkPeriodTemplatePage extends Page {
  title: string = "Szablony czasu pracy";
}
